export default "__VITE_ASSET__a90eaca3__"